import styled from '@emotion/styled';

import Card from 'components/global/Card';

export const ChartCard = styled(Card)`
	padding-bottom: 5rem;
	padding-top: 2rem;
	padding-left: 2.5rem;
`;
